jQuery(document).ready(function($) {

    if ( $("#top-talent").length < 1 ) {
        return;
    }
   
    $("#top-talent").children().each(function() {
        $(this).html($(this).html().replace(/&#8232;/g," "));
        console.log('character removed');
    });

});